import { cashbackGrowthDismissedKey, cashbackGrowthOrderSnapshotKey } from '../utils/storageKeys';
import { CashbackGrowthOrderSnapshot, parseCashbackGrowthOrderSnapshot } from './cashbackGrowthOrderSnapshot';

const DISMISSED_VALUE = 'true';

export const isCashbackGrowthModalDismissed = (publicApiKey: string, orderId: string): boolean =>
  localStorage.getItem(cashbackGrowthDismissedKey(publicApiKey, orderId)) === DISMISSED_VALUE;

export const readCashbackGrowthOrderSnapshot = (publicApiKey: string): CashbackGrowthOrderSnapshot | null =>
  parseCashbackGrowthOrderSnapshot(localStorage.getItem(cashbackGrowthOrderSnapshotKey(publicApiKey)));

const persistSnapshot = (publicApiKey: string, snapshot: CashbackGrowthOrderSnapshot): void => {
  localStorage.setItem(cashbackGrowthOrderSnapshotKey(publicApiKey), JSON.stringify(snapshot));
};

export const dismissCashbackGrowth = (publicApiKey: string, snapshot: CashbackGrowthOrderSnapshot): void => {
  localStorage.setItem(cashbackGrowthDismissedKey(publicApiKey, snapshot.orderId), DISMISSED_VALUE);
  persistSnapshot(publicApiKey, snapshot);
};

export const writeCashbackGrowthOrderSnapshot = (publicApiKey: string, snapshot: CashbackGrowthOrderSnapshot): void => {
  persistSnapshot(publicApiKey, snapshot);
};
